<template>
  <section class='toolbarContent__linkApps' :class="{'mobile': mobile}" id="greySites">
    <section class="toolbarContent__linkApps--header" v-if="mobile">
      <span class="label bookFont">Grey Sites and Tools</span>
      <span class="icon-grey-close close" v-if="mobile" @click="closeHelp"></span>
    </section>
    <section class='toolbarContent__linkApps--content'>
      <transition-staggered
        tag="ul"
        className=""
        type="horizontally"
      >
        <li
          class='links'
          v-for='(item, index) in apps'
          :key='item.name'
          :data-index='index'
        >
          <a :href="getLink(item.name)" v-if="item.name !== 'line'" class="content" :class="{'hoverActive': !isMobile, 'disable': item.disable}" @click.stop.prevent='goToApp(item.name)'>
            <span v-if="item.icon" :class='`icon-grey-${item.icon}`' class="icon" />
            <div class='textCount'>
              <span class='text bookFont'>{{ filters.sitesNames(item.name) }}</span>
              <span v-if="item.count" class='count bookFont'>{{ item.count }}</span>
              <span v-if="item.rightIcon" :class='`icon-grey-${item.rightIcon} icon`' />
            </div>
          </a>
          <div v-else class="line"/>
        </li>
      </transition-staggered>
    </section>
  </section>
</template>

<script>
import { computed, reactive } from 'vue'
import transitionStaggered from '../transitions/transitionStaggered'
import filters from '../../utils/filters'
import configEndPoints from '../../config.json'

export default {
  name: 'greySites',
  props: {
    apps: {
      type: Array,
      required: true
    },
    mobile: {
      type: Boolean,
      required: true
    }
  },
  components: {
    transitionStaggered
  },
  emits: ['close-greysites-menu', 'go-back', 'open-help', 'go-to-app'],
  setup (props, { emit }) {
    /**
      * @description Check device
      */
    const isMobile = computed(() => {
      return navigator.userAgent.match(/Android|iPhone|iPad/i)
    })

    /**
     * @description Close menu
     */
    function closeHelp () {
      emit('close-greysites-menu')
    }

    /**
     * @description Go back apps menu
     */
    function goBack () {
      emit('go-back', 'apps')
    }

    /**
     * @description Open in a new tab the app selected
     * @param app App name
     */
    function goToApp (app) {
      if (app === 'Help') {
        emit('open-help')
        return
      }
      emit('go-to-app', app)
    }

    /**
     * @description Returns acording the site name
     * @param appName Name of the app
     */
    function getLink(appName){
      switch(appName) {
        case 'Work':
          return this.appConfig.apps_url.work
        break
        case 'Intelligence':
          return this.appConfig.apps_url.intelligence
        break
        case 'People Finder':
          return this.appConfig.apps_url.people
        break
        case 'News':
          return this.appConfig.apps_url.news
        break
        case 'Culture Daily':
          return this.appConfig.apps_url.cultureDaily
        break
        case 'Office 365':
          return this.appConfig.apps_url.office
        break
        case 'Centers of Excellence':
          return this.appConfig.apps_url.theHive
        break
        case 'Help':
          return this.appConfig.apps_url.help
        break
        case 'Home':
          return this.appConfig.apps_url.gogrey
        break
        case 'Borderless Opportunities':
          return this.appConfig.apps_url.opportunities
        break
      }
    }
    
    /**
     * @description Contains the conntent of config.json 
     */
    const appConfig = reactive(configEndPoints)

    return {
      isMobile,
      closeHelp,
      goBack,
      goToApp,
      filters,
      appConfig,
      getLink
    }
  }
}
</script>
